var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductFilter',{attrs:{"isOnProductDetailPage":_vm.isOnProductDetailPage,"placeholderText":_vm.placeholderText,"totalFiltersActive":_vm.totalFiltersActive,"filterType":"product","title":"Product Types","tooltipText":"For example, belt or hat"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27db2ed2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/ProductFilterProductTypes.vue
// module id = wE+R
// module chunks = 1